import React, { useState } from 'react';
import Lottie from 'react-lottie-player';
import contactAnimation from '../animations/contact.json';

export default function Contact() {

    return(
        <div className="contact">
            <Lottie
                loop
                animationData={contactAnimation}
                play
                className="contact__waves"
                style={{width: '100%'}}
            />
            <div className="text__center">
                <h4>Contact us at <br /> <a href="mailto:info@interviewai.eu?subject=I%20need%20help" className="btn btn__primary-soft text__bold font__30 btn__sm">info@interviewai.eu</a> <br/> to learn more...</h4>
            </div>
        </div>
    )
}